import styled from 'styled-components';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import COLORS from '../../../common/styles/color-pallete';
import DEVICES from '../../../common/styles/devices';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';

export const PayoutMethod = styled.div`
  height: 45px;
  display: flex;
  flex-direction: column;
`;

export const StyledGridColumn = styled(Grid.Column)`
  ${(props) =>
    props.noPaddingLeft &&
    `
    &&& {
      padding-left: 0 !important;
      width: 90%; 
    }
  `}
`;

export const RenderRecevingOptions = styled.div`
  max-width: 325px;
  @media only screen and (max-width: 1080px) {
    display: flex;
    justify-content: center;
    .innerBox {
      width: 325px;
    }
  }
`;

export const RenderRecipientNote = styled.div`
  margin-top: -4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  text-align: left;
  max-width: 511px;
  font-size: 12px;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-weight: 400;
  line-height: 16px;
  a {
    color: ${COLORS.brandPrimary};
  }
  a:hover {
    color: ${COLORS.brandPrimary};
  }
`;

export const Container = styled(Grid)`
  margin: auto !important;
  @media only screen and (max-width: 1080px) {
    display: flex;
    justify-content: center;
    .innerBox {
      width: 325px;
    }
  }
`;

export const RenderTitle = styled.div`
  height: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  text-align: center;
  color: ${COLORS.black};
  display: flex;
  flex-direction: row;
`;

export const SubTitle = styled.div`
  height: 19px;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${COLORS.textLightGrey};
`;

export const NewIcon = styled.img`
  padding-left: 15px;
  ${(props) => props.style}
`;

const formatMargin = (props) => {
  if (!props.margin) return '44px 0 15px 10px';
  const [top, right = 0, bottom = top, left = right] = props.margin;
  return `${top} ${right} ${bottom} ${left}`;
};

export const SectionTitle = styled.div`
  display: flex;
  width: 100%;
  font-size: 20px;
  font-weight: 500;
  color: ${COLORS.black};
  margin: ${formatMargin};

  @media screen and (max-width: 1080px) {
    justify-content: center;
  }
`;

export const PersonalFieldRelationshipContainer = styled.div`
  padding-top: 10px;
  .input-error-wrapper {
    max-width: ${(p) => (p.$isSingleRowField ? '100%' : '325px')} !important;
  }
  @media only screen and (max-width: 1080px) {
    display: ${(p) => (p.$isSingleRowField ? 'block' : 'flex')};
    justify-content: center;
    .innerBox {
      width: 325px;
    }
    @media ${DEVICES.mobileXL} {
      .input-error-wrapper {
        max-width: unset;
        width: 100%;
      }
    }
  }
`;

export const PersonalContainer = styled.div`
  display: grid;
  grid-template-columns: ${(p) => (p.$isSingleRowField ? '1fr' : '33.33% 33.33% 33.33%')};
  row-gap: ${(p) => (p.$isSingleRowField ? '0px' : '40px')};
  justify-content: center;

  .input-error-wrapper {
    max-width: ${(p) => (p.$isSingleRowField ? '100%' : '325px')} !important;
  }

  div {
    margin: ${(p) => !p.$isSingleRowField && '0px'};
  }

  @media only screen and (max-width: 1080px) {
    display: ${(p) => (p.$isSingleRowField ? 'grid' : 'flex')};
    flex-direction: column;
    row-gap: ${(p) => (p.$isSingleRowField ? '0px' : '40px')};
    margin: auto;
  }

  @media ${DEVICES.laptopS} {
    .input-error-wrapper {
      margin-top: ${(p) => (p.$isSingleRowField ? '0px' : '50px')};
    }
  }

  @media ${DEVICES.mobileXL} {
    .input-error-wrapper {
      max-width: unset;
      width: 100%;
    }
  }
`;

export const PayoutContainer = styled.div`
  ${(p) =>
    p.isSingleRowField
      ? `
        display: flex;
        flex-direction: column;
        row-gap: 0px !important;
      `
      : `
        display: grid;
        grid-template-columns: 33.33% 33.33% 33.33%;
        row-gap: 40px;
  `};

  justify-content: center;
  .input-error-wrapper {
    ${(p) => !p.isSingleRowField && 'max-width: 325px !important;'}
  }
  div {
    margin: 0px;
  }
  .IFSC_text {
    ${(p) => !p.isSingleRowField && 'max-width: 325px'}
    width: 100%;
    text-align: right;
    padding-right: 10px;
  }
  @media only screen and (max-width: 1080px) {
    display: flex;
    flex-direction: column;
    row-gap: ${(p) => (p.$isSingleRowField ? '0px' : '20px')};
    margin-bottom: 20px;
  }
  @media ${DEVICES.mobileXL} {
    .input-error-wrapper {
      max-width: unset;
      width: 100%;
    }
  }
`;
export const AddressContainer = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  row-gap: 40px;
  justify-content: center;
  .input-error-wrapper {
    max-width: 325px !important;
  }
  div {
    margin: 0px;
  }
  @media only screen and (max-width: 1080px) {
    grid-template-columns: auto;
    row-gap: 20px;
    margin: auto;
  }
`;

export const MobileNumberContainer = styled(Grid.Column)`
  display: flex !important;
  flex-direction: row;
`;

export const MobileCode = styled.div`
  flex-shrink: 1;
`;

export const MobileNumber = styled.div`
  padding-left: 10px;
  flex: 1;
`;

export const GridColumn = styled(Grid.Column)``;

export const BankNameContainer = styled.div`
  display: flex;
  margin: 24px 0;
  .info-icon {
    margin: 4px 8px 0;
  }
  .bankingName {
    display: flex;
  }
  .bankNameText {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    line-height: 22px;
  }
  .name {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 16px;
    line-height: 22px;
    color: ${COLORS.lightGreen};
    margin-left: 8px;
  }
  .infoIcon {
    width: 16px;
    height: 24px;
    cursor: pointer;
    margin: 0 4px;
  }
  .bankNamePopup {
    font-size: 14px;
    line-height: 22px;
  }
`;
